import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable, DatePicker } from 'components';
import { UserService, AuthService } from 'services';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
	document_types: any;
	phonecodes: any;
	states: any;
}

class ModalCreate extends React.Component<Props> {
	state = {
		form: {
			name: '',
			email: '',
			document: '',
			document_type_id: this.props.document_types.length > 0 ? this.props.document_types[0].id : '',
			phonecode_id: this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : '',
			phone: '',
			password: '',
			password_confirmation: '',
			photo: '',
			birthdate: '',
			state_id: '',
			city_id: '',
			level_id: Constants.LEVELS.USER,
		},
		cities: [],
		// Animales
		animals_pets: [] as string[],
		animals_farm: [] as string[],
		has_pets: false,
		has_farm: false,
	};

	componentDidMount() {
		if (this.props.item) {
			console.log(this.props.item)
			const pets = (this.props.item.user_animals || [])
				.filter((a: any) => a.type === 1)
				.map((a: any) => a.name);

			const farms = (this.props.item.user_animals || [])
				.filter((a: any) => a.type === 2)
				.map((a: any) => a.name);

			this.setState(
				{
					form: {
						...this.state.form,
						name: this.props.item?.name,
						email: this.props.item?.email,
						document_type_id:
							this.props.item?.document_type_id ||
							(this.props.document_types.length > 0 ? this.props.document_types[0].id : ''),
						phonecode_id:
							this.props.item?.phonecode_id ||
							(this.props.phonecodes.length > 0 ? this.props.phonecodes[0].id : ''),
						document: this.props.item?.document || '',
						phone: this.props.item?.phone || '',
						birthdate: this.props.item?.birthdate ? moment(this.props.item?.birthdate).toDate() : '',
						state_id: this.props.item?.state_id || '',
						city_id: this.props.item?.city_id || '',
						level_id: this.props.item?.level_id || '',
					},
					animals_pets: pets,
					animals_farm: farms,
					has_pets: pets.length > 0,
					has_farm: farms.length > 0,
				},
				() => this.getCities(),
			);
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		// Construimos el array de animales para el backend
		const animals: any[] = [];

		if (this.state.has_pets) {
			this.state.animals_pets
				.map((name) => (name || '').trim())
				.filter((name) => name !== '')
				.forEach((name) => {
					animals.push({
						name,
						type: 1, // Mascota
					});
				});
		}

		if (this.state.has_farm) {
			this.state.animals_farm
				.map((name) => (name || '').trim())
				.filter((name) => name !== '')
				.forEach((name) => {
					animals.push({
						name,
						type: 2, // Granja
					});
				});
		}

		const payload = {
			user_id: this.props.item?.id || null,
			...this.state.form,
			birthdate: this.state.form.birthdate
				? moment(this.state.form.birthdate).format('YYYY-MM-DD')
				: '',
			animals, // siempre enviamos animals (puede ir vacío para borrar)
		}

		console.log('Payload submit:', payload);

		await UserService.admin.createOrUpdate(payload);

		Globals.showSuccess('Datos guardados correctamente');
		Socket.emit(SocketEvents.UPDATE_USER, {
			user_id: this.props.item?.id,
		});
		this.props.onClose();
	};

	change = (e: any, callback = () => { }) => {
		this.setState(
			{
				form: {
					...this.state.form,
					[e.target.name]: e.target.value,
				},
			},
			callback,
		);
	};

	getCities = async () => {
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id,
		});
		this.setState({
			cities: res.cities,
		});
	};

	// ----- Helpers Animales -----

	setHasPets = (value: boolean) => {
		this.setState((prev: any) => ({
			has_pets: value,
			animals_pets: value ? prev.animals_pets.length ? prev.animals_pets : [''] : [],
		}));
	};

	setHasFarm = (value: boolean) => {
		this.setState((prev: any) => ({
			has_farm: value,
			animals_farm: value ? prev.animals_farm.length ? prev.animals_farm : [''] : [],
		}));
	};

	addPet = () => {
		this.setState((prev: any) => ({
			animals_pets: [...prev.animals_pets, ''],
			has_pets: true,
		}));
	};

	changePetName = (index: number, value: string) => {
		const animals_pets = [...this.state.animals_pets];
		animals_pets[index] = value;
		this.setState({ animals_pets });
	};

	removePet = (index: number) => {
		const animals_pets = this.state.animals_pets.filter((_: any, i: number) => i !== index);
		this.setState({
			animals_pets,
			has_pets: animals_pets.length > 0,
		});
	};

	addFarm = () => {
		this.setState((prev: any) => ({
			animals_farm: [...prev.animals_farm, ''],
			has_farm: true,
		}));
	};

	changeFarmName = (index: number, value: string) => {
		const animals_farm = [...this.state.animals_farm];
		animals_farm[index] = value;
		this.setState({ animals_farm });
	};

	removeFarm = (index: number) => {
		const animals_farm = this.state.animals_farm.filter((_: any, i: number) => i !== index);
		this.setState({
			animals_farm,
			has_farm: animals_farm.length > 0,
		});
	};

	render() {
		const { form } = this.state;
		const isSubmitDisabled =
			form.name === '' ||
			form.email === '' ||
			form.document === '' ||
			form.phone === '' ||
			form.birthdate === '' ||
			form.state_id === '' ||
			form.city_id === '';

		return (
			<div id="modal-create-client">
				{/* Estilos específicos para la sección de animales */}
				<style>{`
          #modal-create-client .animals-wrapper {
            margin-top: 20px;
            padding-top: 16px;
            border-top: 1px solid #ececec;
          }
          #modal-create-client .animals-title-main {
            font-weight: 600;
            margin-bottom: 8px;
          }
          #modal-create-client .animals-section {
            border-top: 1px solid #f0f0f0;
            padding-top: 14px;
            margin-top: 14px;
          }
          #modal-create-client .animals-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          }
          #modal-create-client .animals-label {
            font-weight: 500;
          }
          #modal-create-client .animals-toggle {
            display: flex;
            gap: 12px;
            align-items: center;
            font-size: 14px;
          }
          #modal-create-client .animals-radio {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            user-select: none;
          }
          #modal-create-client .animals-radio input {
            display: none;
          }
          #modal-create-client .animals-radio-circle {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 2px solid #c3c3c3;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          #modal-create-client .animals-radio-circle span {
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
          #modal-create-client .animals-radio--active .animals-radio-circle {
            border-color: #7a9232;
          }
          #modal-create-client .animals-radio--active .animals-radio-circle span {
            background-color: #7a9232;
          }
          #modal-create-client .animals-add-btn {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 10px;
            border-radius: 20px;
            background-color: #f9a825;
            color: #fff;
            font-size: 13px;
            font-weight: 500;
            border: none;
            cursor: pointer;
            margin-bottom: 10px;
          }
          #modal-create-client .animals-add-btn span {
            font-size: 16px;
            line-height: 1;
          }
          #modal-create-client .animals-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          #modal-create-client .animals-row {
            display: flex;
            align-items: center;
            gap: 8px;
          }
          #modal-create-client .animals-row .form-group {
						margin-bottom: 0px;
					}
          #modal-create-client .animals-delete {
            cursor: pointer;
            font-size: 48px;
						line-height: 48px;
            color: #d32f2f;
            padding: 2px;
						margin-bottom: 10px;
          }
        `}</style>

				<form className="row" onSubmit={this.submit}>
					<div className="col-12">
						
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={this.state.form.name}
							name="name"
							placeholder="Nombre y Apellido"
							label="Nombre y Apellido"
							onChange={this.change}
						/>
					</div>

					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Tipo de Documento</p>
							<div>
								<Select
									className="document_type"
									name="document_type_id"
									onChange={this.change}
									value={this.state.form.document_type_id}
									options={this.props.document_types.map((i: any) => {
										return {
											value: i.id,
											label: i.name,
										};
									})}
								/>
								<Input
									type="number"
									color="white"
									value={this.state.form.document}
									name="document"
									placeholder="Documento"
									onChange={this.change}
									maxLength={9}
								/>
							</div>
						</div>
					</div>

					<div className="col-md-6">
						<Input
							color="white"
							value={this.state.form.email}
							name="email"
							placeholder="Correo Electrónico"
							label="Correo Electrónico"
							onChange={this.change}
						/>
					</div>
					<div className="col-md-6">
						<DatePicker
							showYearDropdown={true}
							label="Fecha de Nacimiento"
							maxDate={moment().toDate()}
							onChange={(text: string) => {
								this.change({
									target: {
										value: text,
										name: 'birthdate',
									},
								});
							}}
							value={this.state.form.birthdate}
						/>
					</div>
					<div className="col-md-6">
						<div className="container-select">
							<p className="label">Teléfono</p>
							<div>
								<Select
									name="phonecode_id"
									onChange={this.change}
									value={this.state.form.phonecode_id}
									options={this.props.phonecodes.map((i: any) => {
										return {
											value: i.id,
											label: i.name,
										};
									})}
								/>
								<Input
									type="number"
									color="white"
									value={this.state.form.phone}
									name="phone"
									placeholder="Teléfono"
									onChange={this.change}
									maxLength={7}
								/>
							</div>
						</div>
					</div>

					<div className="col-md-6"></div>

					<div className="col-md-6">
						<Select
							className="speciality_select"
							label="Estado"
							name="state_id"
							onChange={(e: any) =>
								this.change(e, () => {
									this.setState(
										{
											form: {
												...this.state.form,
												city_id: '',
											},
										},
										() => this.getCities(),
									);
								})
							}
							value={this.state.form.state_id}
							options={this.props.states.map((i: any) => {
								return {
									value: i.id,
									label: i.name,
								};
							})}
						/>
					</div>
					<div className="col-md-6">
						<Select
							className="speciality_select"
							label="Ciudad"
							disabled={!this.state.form.state_id}
							name="city_id"
							onChange={this.change}
							value={this.state.form.city_id}
							options={this.state.cities.map((i: any) => {
								return {
									value: i.id,
									label: i.name,
								};
							})}
						/>
					</div>

					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={this.state.form.password}
							name="password"
							placeholder="Contraseña"
							label="Contraseña"
							onChange={this.change}
						/>
					</div>
					<div className="col-md-6">
						<Input
							type="password"
							color="white"
							value={this.state.form.password_confirmation}
							name="password_confirmation"
							placeholder="Repetir Contraseña"
							label="Repetir Contraseña"
							onChange={this.change}
						/>
					</div>

					{/* --------- Sección de Animales --------- */}
					<div className="col-12">
						<div className="animals-wrapper">
							<p className="animals-title-main">Animales</p>

							{/* Mascotas */}
							<div className="animals-section">
								<div className="animals-header">
									<span className="animals-label">¿Tiene mascota?</span>
									<div className="animals-toggle">
										<label
											className={`animals-radio ${this.state.has_pets ? 'animals-radio--active' : ''
												}`}
										>
											<input
												type="radio"
												name="has_pets"
												checked={this.state.has_pets}
												onChange={() => this.setHasPets(true)}
											/>
											<span className="animals-radio-circle">
												<span />
											</span>
											Si
										</label>
										<label
											className={`animals-radio ${!this.state.has_pets && this.state.animals_pets.length === 0
													? 'animals-radio--active'
													: ''
												}`}
										>
											<input
												type="radio"
												name="has_pets"
												checked={!this.state.has_pets && this.state.animals_pets.length === 0}
												onChange={() => this.setHasPets(false)}
											/>
											<span className="animals-radio-circle">
												<span />
											</span>
											No
										</label>
									</div>
								</div>

								{this.state.has_pets && (
									<>
										<button
											type="button"
											className="animals-add-btn"
											onClick={this.addPet}
										>
											<span>+</span> Agregar especie
										</button>
										<div className="animals-list">
											{this.state.animals_pets.map((name, index) => (
												<div className="animals-row" key={`pet-${index}`}>
													<div style={{ flex: 1 }}>
														<Input
															color="white"
															placeholder="Especie (ej: Perro, Gato...)"
															value={name}
															name={`pet-${index}`}
															onChange={(e: any) =>
																this.changePetName(index, e.target.value)
															}
														/>
													</div>
													<div
														className="animals-delete"
														onClick={() => this.removePet(index)}
													>
														×
													</div>
												</div>
											))}
										</div>
									</>
								)}
							</div>

							{/* Animales de granja */}
							<div className="animals-section">
								<div className="animals-header">
									<span className="animals-label">¿Tienes animales de granja?</span>
									<div className="animals-toggle">
										<label
											className={`animals-radio ${this.state.has_farm ? 'animals-radio--active' : ''
												}`}
										>
											<input
												type="radio"
												name="has_farm"
												checked={this.state.has_farm}
												onChange={() => this.setHasFarm(true)}
											/>
											<span className="animals-radio-circle">
												<span />
											</span>
											Si
										</label>
										<label
											className={`animals-radio ${!this.state.has_farm && this.state.animals_farm.length === 0
													? 'animals-radio--active'
													: ''
												}`}
										>
											<input
												type="radio"
												name="has_farm"
												checked={!this.state.has_farm && this.state.animals_farm.length === 0}
												onChange={() => this.setHasFarm(false)}
											/>
											<span className="animals-radio-circle">
												<span />
											</span>
											No
										</label>
									</div>
								</div>

								{this.state.has_farm && (
									<>
										<button
											type="button"
											className="animals-add-btn"
											onClick={this.addFarm}
										>
											<span>+</span> Agregar especie
										</button>
										<div className="animals-list">
											{this.state.animals_farm.map((name, index) => (
												<div className="animals-row" key={`farm-${index}`}>
													<div style={{ flex: 1 }}>
														<Input
															color="white"
															placeholder="Especie (ej: Caballo, Cabra...)"
															value={name}
															name={`farm-${index}`}
															onChange={(e: any) =>
																this.changeFarmName(index, e.target.value)
															}
														/>
													</div>
													<div
														className="animals-delete"
														onClick={() => this.removeFarm(index)}
													>
														×
													</div>
												</div>
											))}
										</div>
									</>
								)}
							</div>
						</div>
					</div>

					{/* Botones */}
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-6 text-center">
								<Button type="button" className="btn-close" onClick={() => this.props.onClose()}>
									Cerrar
								</Button>
							</div>
							<div className="col-md-6 text-center">
								<Button 
									type="submit"
									disabled={isSubmitDisabled}
								>
									Guardar
								</Button>
							</div>
						</div>
					</div>
				</form>
			</div>
		);
	}
}

export default ModalCreate;